import React from 'react';

import { CheckboxStyled } from './style';

const defaultProps = {};

export default React.forwardRef((props, ref) => (
  <CheckboxStyled {...defaultProps} {...props} ref={ref} />
));
